import Headling from './headling.vue';

export default Headling;
